import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import Notification from '../UI/Notification/Notification';
import Layout from '../../containers/Layout/Layout';
import Auth from '../../containers/Auth/Auth';
import * as actions from '../../store/actions/';
import Routes from '../Routes/Routes';
import LoadingBar from '../UI/LoadingBar/LoadingBar';
import CookieConsent, {
  Cookies,
  getCookieConsentValue,
} from 'react-cookie-consent';
import CartPage from '../../pages/CartPage/CartPage';
import ReactGA from 'react-ga4';
import moment from 'moment/moment';
import bootstrapCss from 'bootstrap/dist/css/bootstrap.min.css';
import brandonTextFont from '../../assets/fonts/BrandonText-Regular.woff2';
import indexCSS from '../../index.css';

import imageAutokino from '../../assets/images/autokino/home/Autokino.jpg';
import imageAutokinoWebp from '../../assets/images/autokino/home/Autokino.webp';
import imageAutokinoDesktop from '../../assets/images/autokino/home/desktop/Autokino.jpg';
import imageAutokinoWebpDesktop from '../../assets/images/autokino/home/desktop/Autokino.webp';

import imageFlohmarkt from '../../assets/images/autokino/home/Flohmarkt.jpg';
import imageFlohmarktWebp from '../../assets/images/autokino/home/Flohmarkt.webp';
import imageFlohmarktDesktop from '../../assets/images/autokino/home/desktop/FM.jpg';
import imageFlohmarktWebpDesktop from '../../assets/images/autokino/home/desktop/FM.webp';

import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { preload } from 'react-dom';
import MailjetScript from '../Util/MailjetScript';

class App extends React.Component {
  state = {
    isSubscribed: false,
    cart: this.props.cart,
  };

  componentDidMount() {
    document.getElementById('initial_loader').classList.add('hidden');
    //this.props.onSubscribeAuthState();
    //var item = cookie.load('cart', false);
    var item = localStorage.getItem('cart');
    if (item) {
      try {
        item = JSON.parse(item);
      } catch {
        localStorage.setItem('cart', '{}');
      }
    }

    //console.log("######## cookie consent: "+getCookieConsentValue("autokinoTicketshopCookie") + " value: "+ (getCookieConsentValue("autokinoTicketshopCookie")==="true"));
    if (
      getCookieConsentValue('autokinoTicketshopCookie') &&
      getCookieConsentValue('autokinoTicketshopCookie') === 'true'
    ) {
      this.initTracking();
    }

    console.log('componentDidMount cart item loaded: ' + JSON.stringify(item));
    if (item && item !== undefined) {
      //check for expired items and clear basket if ticket for expired show is present

      var clearbasket = false;
      Object.values(item).forEach(p => {
        if (p.show && p.show.date) {
          let showdate = moment(p.show.date, 'DD.MM.YYYY');
          let currentDate = moment();
          if (showdate.isValid() && showdate.isBefore(currentDate)) {
            console.log(
              'showdate: ' + p.show.date + ' is smaller than current date'
            );
            clearbasket = true;
          }
        }
        console.log(JSON.stringify(p));
      });
      console.log('clearBasket: ' + clearbasket);
      if (clearbasket) {
        localStorage.setItem('cart', '{}');
      } else {
        let total = CartPage.calcTotalPrice(item);
        // let cart = JSON.parse(item);
        if (this.props) {
          //this.props.onSubscribeCart(item, total);
        }
      }
      // this.setState({ cart : item });
    }
  }

  initTracking() {
    console.log('!!!init tracking called');
    ReactGA.initialize('G-2ZNV6BW413', {
      gaOptions: {
        //transport_url: 'https://gtm.autokino.at' // dein Server-Side-Container-Endpunkt
      }
    });
    const options = {
      autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
      debug: true, // enable logs
    };
    const ReactPixel = require('react-facebook-pixel');
    ReactPixel.default.init('2123680111249163', null, options);

    ReactPixel.default.revokeConsent();
  }

  componentWillUnmount() {
    actions.unsubscribeAuthState();
    if (this.state.isSubscribed) {
      this.props.onUnsubscribeCart();
    }
  }

  render() {
    preload(brandonTextFont, { as: "font" });
    preload(bootstrapCss, { as: "style" });
    preload(indexCSS, { as: "style" });
    preload(imageAutokino, {
      as: "image",
      imageSrcSet: imageAutokino + " 512w, " + imageAutokinoDesktop + " 1024w",
      imageSizes: "(max-width: 512px) 512px, 1024px",
    });
    preload(imageFlohmarkt, {
      as: "image",
      imageSrcSet: imageFlohmarkt + " 512w, " + imageFlohmarktDesktop + " 1024w",
      imageSizes: "(max-width: 512px) 512px, 1024px",
    });
    return (
      <div>
        <Helmet
          defaultTitle="Autokino Wien / Flohmarkt Wien"
          titleTemplate="%s"
          defer={false}
        />

        <Auth />

        <Layout>
          <Routes />
        </Layout>

        <ToastContainer />

        <LoadingBar show={this.props.showLoadingBar} />

        <Notification
          text={this.props.errorText}
          show={this.props.error}
          onOpen={this.props.onRemoveError}
          options={{ type: 'fail' }}
        />

        <Notification
          text={this.props.notificationText}
          show={this.props.notification}
          onOpen={this.props.onRemoveNotification}
          options={{ type: 'success' }}
        />

        <CookieConsent
          location="top"
          buttonText="Akzeptieren"
          declineButtonText="Ablehnen"
          enableDeclineButton={true}
          cookieName="autokinoTicketshopCookie"
          style={{ background: '#2B373B' }}
          expires={1000}
          onAccept={acceptedByScrolling => {
            this.initTracking();
          }}
          onDecline={() => {
            console.log('cookie consent declined, do not init tracking');
          }}
        >
          Diese Website benutzt Cookies. Wenn Sie die Website weiter nutzen,
          gehen wir von Ihrem Einverständnis aus.{' '}
        </CookieConsent>
        <MailjetScript />
      </div>
    );
  }
}

App.propTypes = {
  error: PropTypes.bool,
  errorText: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  notification: PropTypes.bool,
  notificationText: PropTypes.string,
  cart: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    error: state.errors.error,
    errorText: state.errors.text,
    notification: state.notifications.notification,
    notificationText: state.notifications.text,
    isAuthenticated: state.auth.isAuth,
    cart: state.cart.cart,
    showLoadingBar: state.loadingBar.show,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSubscribeWishlist: () => dispatch(actions.subscribeWishlist()),
    onUnsubscribeWishlist: () => dispatch(actions.unsubscribeWishlist()),
    onSubscribeCart: (cart, total) => dispatch(actions.updateCart(cart, total)),
    onUnsubscribeCart: () => dispatch(actions.unsubscribeCart()),
    onRemoveError: () => dispatch(actions.removeError()),
    onSubscribeAuthState: () => dispatch(actions.subscribeAuthState()),
    onRemoveNotification: () => dispatch(actions.removeNotification()),
  };

};

//export default App;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

